export const CHECK_STATUS_EVENT = "CHECK_STATUS_EVENT";
export const GET_STATISTIC = "GET_STATISTIC";
export const PAIRING_EVENT_2024 = "PAIRING_EVENT_2024";
export const START_OPEN_GIFT = "START_OPEN_GIFT";
export const HISTORY_OPEN_GIFT_NOEL = "HISTORY_OPEN_GIFT_NOEL";
export const USER_CODE = "USER_CODE";
export const CODE_DETAIL = "CODE_DETAIL";
export const RECEIVE_CODE = "RECEIVE_CODE";
export const GET_RANK = "GET_RANK";
export const HISTORY_OPEN_GIFT_NOEL_SPECIAL = "HISTORY_OPEN_GIFT_NOEL_SPECIAL";
